/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { IErrorMessage } from "../../models/Machines/ClientContracts";
import { SHOW_ERROR } from "./types";

export const showErrorAction = (error: IErrorMessage) => {
  return {
    type: SHOW_ERROR,
    error
  };
};
